import {
  Block,
  Branch,
  Repository,
  getPossibleVariables,
  getPreviewURL,
  resolveInputWithVars,
} from '@basehub/data/replicache/index'
import { AtLeast, TreeManager } from '@basehub/utils/tree/index'
import { polishRepoPreviewURL } from '@basehub/utils/url-misc/preview'

export const resolveWebhookUrl = ({
  url,
  treeManager,
  blockId,
  origin,
}: {
  url: string
  treeManager: TreeManager<Block, any>
  blockId: string
  origin: string
}) => {
  const nodeBlock = treeManager.getNode(blockId, { required: true })
  const rootOptions = [
    {
      name: '_origin',
      value: origin,
      node: null,
    },
    {
      name: '_vercel_draft',
      value: '__vercel_draft=1',
      node: null,
    },
    {
      name: '_root',
      value: 'Root Block',
      node: treeManager.root,
    },
  ]
  return resolveInputWithVars(url, {
    getVariables: (segments) => {
      return getPossibleVariables({
        segments,
        nodeBlock,
        treeManager: treeManager as any,
        valueKey: 'value',
        rootOptions,
        selectedVariants: null,
      })
    },
    getPreviewUrl: (node) => {
      if (node.key === nodeBlock.key) {
        // prevent infinite loop
        return ''
      }
      return getPreviewURL({
        nodeBlock: node,
        blockTreeManager: treeManager as any,
        previewToken: undefined,
        rootOptions,
        origin,
        selectedVariants: null,
      })
    },
  })
}

export const getOriginUrl = ({
  branch,
  repo,
}: {
  branch: Branch | null
  repo: AtLeast<Repository, 'previewUrl'> | null
}) => {
  const gitDeploymentUrl = branch ? (branch.git?.deploymentUrl ?? null) : null
  return polishRepoPreviewURL(gitDeploymentUrl ?? repo?.previewUrl) || ''
}
